import { WASHMEN_CUSTOMER_API } from 'api/config';
import type { Customer } from 'api/types/user.types';

export async function fetchCarouselData() {
  const {
    data: { carouselItemList },
  } = await WASHMEN_CUSTOMER_API.get<Customer.CarouselData>('/stories/carousel-items');
  return carouselItemList;
}
